export const DodgeFront = 'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Toronto/Uber/Dodge+Front.png';

export const BmwFront = 'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Toronto/Uber/BMW+Front.png';

export const bmwTopViewNoShadow =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Half+Size/BMW+Top+View+no+shadow+half.png';

export const dodgeTopViewNoShadow =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/DodgeHalfSize/Dodge+Top+View+no+shadow+half.png';

export const plusGraphic =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Toronto/Uber/Plus+Graphic+Black.png';

export const proGraphic =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Toronto/Uber/Pro+Graphic+Black.png';

export const plusBottom =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Toronto/Uber/plus-arrows-bottom.svg';

export const plusTop = 'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Toronto/Uber/plus-arrows-top.svg';

export const proBottom =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Toronto/Uber/pro-arrrows-bottom.svg';

export const proTop = 'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Toronto/Uber/pro-arrows-top.svg';

export const bmwTopArrows =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Mobile/pro_top--arrows.png';

export const dodgeTopArrows =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Mobile/plus_top--arrows.png';



// WEBPACK FOOTER //
// ./src/images/UberTorontoLinks.js